import SectionTitle from "../components/SectionTitle";
import ContactCard from "./components/ContactCard";

export default function Contact() {
  return (
    <div className="d-flex w-100 lg-align-items-start flex-column pt-4 pb-5 ps-3 pe-3 gap-3">
      <div className="text-center pb-1">
        <SectionTitle title="Contact" />
      </div>
      <ContactCard />
      <div className="pt-3">
        <h5 className="fw-semibold pb-2 text-primary">
          Our main office is at:
        </h5>
        <p>
          Unit 1407 14/F, Jollibee Plaza Bldg, Emerald Avenue Ortigas Center,
          Pasig City
        </p>
      </div>
    </div>
  );
}
